import { useModal } from "@finanedi.es/front/common/hooks"
import { useEmpresaGenerarDocumentoOtorgamientoAeatPost } from "@finanedi.es/front/common/hooks/api"
import { yupResolver } from "@hookform/resolvers/yup"
import { useCallback, useMemo, useState } from "react"
import { useFieldArray, useForm } from "react-hook-form"
import {
  leyAntifraudeFormRepresentantesFormTemplateActions,
  leyAntifraudeFormRepresentantesFormTemplateFields,
  leyAntifraudeFormRepresentantesFormTemplateSchema,
} from "../forms"
import { IUseLeyAntifraudeFormRepresentantesFormTemplateProps } from "../interfaces"
import { createDefaultRepresentante } from "../utils"

export const useLeyAntifraudeFormRepresentantesFormTemplate = ({
  nif,
  razonSocial,
}: IUseLeyAntifraudeFormRepresentantesFormTemplateProps) => {
  const { empresaGenerarDocumentoOtorgamientoAeatPost, loading } =
    useEmpresaGenerarDocumentoOtorgamientoAeatPost()
  const { open: openPdfModal, toggleModal } = useModal()
  const schema = useMemo(
    () => leyAntifraudeFormRepresentantesFormTemplateSchema(),
    []
  )

  const [pdf, setPdf] = useState<Blob>()

  const rhForm = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      empresa_nif: nif,
      empresa_razonSocial: razonSocial,
      empresa_calle: "",
      empresa_numero: "",
      empresa_municipio: "",
      representantes: [createDefaultRepresentante],
    },
  })

  const { fields, append, remove } = useFieldArray({
    control: rhForm.control,
    name: "representantes",
  })

  const handleAddRepresentante = useCallback(() => {
    append(createDefaultRepresentante)
  }, [append])

  const handleRemoveRepresentante = useCallback(
    (index: number) => {
      remove(index)
    },
    [remove]
  )

  const handleOnSubmit = useCallback(async () => {
    const formValues = rhForm.getValues()
    const body = {
      empresa: {
        nif: formValues.empresa_nif,
        razonSocial: formValues.empresa_razonSocial,
        direccion: {
          calle: formValues.empresa_calle,
          numero: formValues.empresa_numero,
          municipio: formValues.empresa_municipio,
        },
      },
      representantes: formValues.representantes.map((rep) => ({
        nombreCompleto: rep.nombreCompleto,
        nif: rep.nif,
        direccion: {
          calle: rep.calle,
          numero: rep.numero,
          municipio: rep.municipio,
        },
      })),
    }
    const res = await empresaGenerarDocumentoOtorgamientoAeatPost(body)
    if (res) {
      toggleModal()
      setPdf(res)
    }
  }, [rhForm, empresaGenerarDocumentoOtorgamientoAeatPost, toggleModal])

  return {
    pdfModal: {
      open: openPdfModal,
      onClose: () => {
        toggleModal()
        setPdf(undefined)
      },
      pdf,
    },
    handleAddRepresentante,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rhForm: rhForm as any,
    fields: leyAntifraudeFormRepresentantesFormTemplateFields({
      fields,
      onRemoveRepresentante: handleRemoveRepresentante,
    }),
    actions: leyAntifraudeFormRepresentantesFormTemplateActions({
      onAddRepresentante: handleAddRepresentante,
      onSubmit: rhForm.handleSubmit(handleOnSubmit),
      loading,
    }),
    containerStyles:
      "fs-flex fs-flex-1 fs-flex-col fs-gap-4 fs-pt-1 1k:fs-pt-4",
    contentStyles:
      "fs-grid fs-grid-cols-12 fs-min-h-0 fs-gap-4 fs-grow fs-w-full ",
    actionsStyles: "fs-flex fs-flex-col-reverse fs-gap-4 laptop:fs-flex-col",
  }
}
